// extracted by mini-css-extract-plugin
export default {"recent":"RecentExp_recent__YXvHe","expenses":"RecentExp_expenses__knyBI"};